// extracted by mini-css-extract-plugin
module.exports = {"root":"TextRenderer_root__b3gh_","strongAsGradient":"TextRenderer_strongAsGradient__dpsnq"};